import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PasswordStrengthMeter from '../components/PasswordStrengthMeter';
import './Auth.css';

function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [passwordMatchError, setPasswordMatchError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setPasswordMatchError('');

    // Validate password match
    if (password !== confirmPassword) {
      setPasswordMatchError('Passwords do not match');
      return;
    }

    setLoading(true);

    // Check for detailed error messages from backend
    const result = await register(name, email, password);
    setLoading(false);

    if (result.success) {
      navigate('/check-email', { state: { email: result.email } });
    } else {
      // Handle detailed validation errors
      if (result.errorDetails && Array.isArray(result.errorDetails)) {
        setError(result.errorDetails.join('. '));
      } else {
        setError(result.error);
      }
    }
  };

  // Check password match in real-time
  useEffect(() => {
    if (confirmPassword && password !== confirmPassword) {
      setPasswordMatchError('Passwords do not match');
    } else {
      setPasswordMatchError('');
    }
  }, [password, confirmPassword]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/tradelensy-logo.png" alt="Tradelensy logo" className="auth-logo" />
          <h1>Tradelensy</h1>
        </div>
        <h2>Register</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              minLength={8}
              maxLength={64}
              autoComplete="new-password"
            />
            <PasswordStrengthMeter password={password} username={name} email={email} />
          </div>
          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
              minLength={8}
              maxLength={64}
              autoComplete="new-password"
            />
            {passwordMatchError && (
              <div className="error-message" style={{ marginTop: '8px', fontSize: '14px' }}>
                {passwordMatchError}
              </div>
            )}
            {confirmPassword && password === confirmPassword && password.length >= 8 && (
              <div style={{ marginTop: '8px', color: '#00c853', fontSize: '14px' }}>
                ✓ Passwords match
              </div>
            )}
          </div>
          <button 
            type="submit" 
            className="btn btn-primary" 
            disabled={loading || password !== confirmPassword || password.length < 8}
          >
            {loading ? 'Registering...' : 'Register'}
          </button>
        </form>
        <p className="auth-link">
          <Link to="/">← Back to home</Link>
        </p>
        <p className="auth-link">
          Already have an account? <Link to="/login">Login here</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
